import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import logo from "../images/Φpost_full.png"
import { useCategories } from "../hooks/use-categories"
import Search from "./search"
import mobileNavMenu from "../images/pageIcons/mobileNavMenu.svg"
import UIkit from 'uikit';

export default function Nav() {

	const { site } = useStaticQuery(
		graphql`
		  query {
			site {
				siteMetadata {
					algolia {
						indexName
					}
				}
			  }
		  }
		`
	 )
	const navbarsearchindex = site.siteMetadata.algolia.indexName
	const searchIndices = [{ name: navbarsearchindex, title: navbarsearchindex }]

	const sortedCats = useCategories()

	const wideCats = sortedCats.map((category) => {
		return (
			<li className="uk-nav-header uk-margin-remove" key={category.node.prismicId}>
				<Link to={`/topic/${category.node.uid}`}>{category.node.data.name}</Link>
			</li>	
		)
	})

	const narrowCats = sortedCats.map((category) => {
		return (
			<li key={category.node.prismicId}>
				<a href={`/topic/${category.node.uid}`}>{category.node.data.name}</a>
			</li>
		)
	})

	return (
		
		<nav className="uk-navbar">

			<div className="uk-navbar-left uk-padding-small uk-padding-remove-bottom uk-padding-remove-top">
				<Link to="/">
					<img src={logo} width="78" height="30" alt="ϕpost" loading="eager" />
				</Link>
			</div>

			<div className="uk-navbar-right">

				<div className="uk-navbar-right uk-visible@m">
					<div>
						<button className="uk-button uk-button-primary" type="button">TOPICS</button>
						<div uk-dropdown="pos: bottom-right" className="uk-margin-remove-top uk-padding-remove">
							<ul className="uk-nav uk-dropdown-nav">
								{wideCats}								
							</ul>
						</div>
					</div>	

					<button className="uk-button uk-button-link" type="button" >
						<Search indices={searchIndices} />
					</button>

				</div>

				<button className="uk-hidden@m uk-button uk-button-link uk-margin-right" uk-toggle="target: #offcanvasNav" type="button" aria-expanded="false">
					<img src={mobileNavMenu} alt="Mobile navigation menu icon" width="20" height="20" />
				</button>

				<div id="offcanvasNav" uk-offcanvas="mode:slide; overlay:true; flip:true" className="uk-offcanvas uk-offcanvas-overlay">
					<div className="uk-offcanvas-bar">
						<ul className="uk-nav uk-nav-default uk-align-right">
							<div className="uk-margin" key="mobileNavBarSearch">
								<Search indices={searchIndices} />	
							</div>			
										
							<li className="uk-nav-divider" key="navDivider1"></li>
							<li className="uk-active uk-margin-small-top" key="mobileNavbarHomeLink"><a href="/">HOMEPAGE</a></li>
							
							<li className="uk-nav-header" key="mobileNavBarTopics">TOPICS</li>
							<ul className="uk-nav-sub">
								{narrowCats}
							</ul>
							<li className="uk-nav-divider" key="navDivider2"></li>
						</ul>
					</div>
				</div>
			</div>
		</nav>	
	)
}